<template>
  <div class="links">
    <span class="callToAction">{{t('Contact us')}}:</span>
    <span class="phoneBlock"><button class="toggleButton btn btn-primary btn-sm" @click="toggleContact('phone')"><i class="fa fa-phone"></i></button><i class="icon fa fa-phone"></i> <span class="phone" v-show="showPhone">+351 936 326 295</span></span>
    <span class="emailBlock"><button class="toggleButton btn btn-primary btn-sm" @click="toggleContact('email')"><i class="fa fa-envelope"></i></button><i class="icon fa fa-envelope"></i> <span class="email" v-show="showEmail">info@booknatura.com</span></span>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

const $ = window.$;

export default {
  name: 'contactUsLinks',
  data: () => ({
    showPhone: true,
    showEmail: true,
  }),
  computed: {
    ...mapState({

    }),
  },
  methods: {
    ...mapActions({

    }),
    toggleContact(type) {
      if (type === 'email') {
        this.showEmail = !this.showEmail;
        this.showPhone = false;
      } else if (type === 'phone') {
        this.showPhone = !this.showPhone;
        this.showEmail = false;
      }
    },
    windowResize() {
      if ($(window).width() > 544) {
        this.showPhone = true;
        this.showEmail = true;
      } else {
        this.showPhone = false;
        this.showEmail = false;
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.windowResize);
    this.windowResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.windowResize);
  },
};

</script>


<style lang="scss" scoped>
@import "../../assets/scss/variables-b4"; /* grid-breakpoints */
.links span {
  display: inline-block;
  color: white;
  font-size: 0.8rem;
}

.emailBlock, .phoneBlock {
  margin-left: 1em;
}
.icon {
  display: none;
}
/* Small Screen 544px */
@media only screen and (min-width: map-get($grid-breakpoints, sm)) {
  .toggleButton {
    display: none !important;
  }
  .icon {
    display: inline-block;
  }
}

</style>




// WEBPACK FOOTER //
// ContactUsLinks.vue?6183083b